module.exports = __webpack_public_path__ + "static/media/scrum4.1ac3c2c6.png";